(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["net.skimatec.moritz.webanmeldung"] = factory();
	else
		root["net.skimatec.moritz.webanmeldung"] = factory();
})(this, () => {
return 